import React from 'react';
import Icon from '../../../components/AppIcon';
import { motion } from 'framer-motion';

const ProgressIndicatorSection = ({ currentStep, currentLanguage }) => {
  const content = {
    EN: {
      steps: [
        { id: 'eligibility', label: 'Check Eligibility', icon: 'CheckCircle' },
        { id: 'application', label: 'Apply', icon: 'FileText' },
        { id: 'complete', label: 'Get Your Card', icon: 'CreditCard' }
      ]
    },
    FR: {
      steps: [
        { id: 'eligibility', label: 'Vérifier admissibilité', icon: 'CheckCircle' },
        { id: 'application', label: 'Postuler', icon: 'FileText' },
        { id: 'complete', label: 'Obtenez votre carte', icon: 'CreditCard' }
      ]
    }
  };

  const text = content?.[currentLanguage] || content?.EN;

  const getStepStatus = (stepId) => {
    const stepOrder = ['eligibility', 'application', 'complete'];
    const currentIndex = stepOrder?.indexOf(currentStep);
    const stepIndex = stepOrder?.indexOf(stepId);
    
    if (stepIndex < currentIndex) return 'completed';
    if (stepIndex === currentIndex) return 'current';
    return 'upcoming';
  };

  return (
    <section className="py-8 bg-white border-b border-gray-200">
      <div className="container mx-auto px-6">
        <div className="max-w-2xl mx-auto">
          <div className="flex items-center justify-between relative">
            {/* Progress Line */}
            <div className="absolute top-6 left-0 w-full h-0.5 bg-gray-200">
              <motion.div
                className="h-full bg-primary"
                initial={{ width: '0%' }}
                animate={{ 
                  width: currentStep === 'eligibility' ? '0%' : 
                         currentStep === 'application' ? '50%' : '100%'
                }}
                transition={{ duration: 0.5 }}
              />
            </div>

            {text?.steps?.map((step, index) => {
              const status = getStepStatus(step?.id);
              
              return (
                <div key={step?.id} className="relative flex flex-col items-center">
                  {/* Step Circle */}
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                    className={`w-12 h-12 rounded-full flex items-center justify-center border-2 transition-colors duration-300 ${
                      status === 'completed' 
                        ? 'bg-success border-success text-white'
                        : status === 'current' ?'bg-primary border-primary text-white' :'bg-white border-gray-300 text-gray-400'
                    }`}
                  >
                    {status === 'completed' ? (
                      <Icon name="Check" size={20} />
                    ) : (
                      <Icon name={step?.icon} size={20} />
                    )}
                  </motion.div>
                  {/* Step Label */}
                  <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 + 0.2 }}
                    className={`mt-3 text-sm font-medium text-center transition-colors duration-300 ${
                      status === 'current' ? 'text-primary' : 'text-gray-500'
                    }`}
                  >
                    {step?.label}
                  </motion.div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgressIndicatorSection;